/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ListAzureVirtualNetworks200ResponseVirtualNetworksInner {
  /**
  * The name of the virtual network
  */
  'name'?: string;
  /**
  * The full Azure resource ID
  */
  'id'?: string;
  /**
  * The Azure region
  */
  'location'?: string;
  /**
  * The address space prefixes
  */
  'addressPrefixes'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "addressPrefixes",
      "baseName": "addressPrefixes",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListAzureVirtualNetworks200ResponseVirtualNetworksInner.attributeTypeMap;
  }

  public constructor() {
  }
}

